import { addHeaderHash } from '@zet/network'

export function clearLoginHash() {
  if (sessionStorage.getItem('hash')) {
    sessionStorage.removeItem('hash')
  }
}
export function setLoginHash(hash: string) {
  sessionStorage.setItem('hash', hash)
}

export function getLoginHash() {
  const params = new URLSearchParams(window?.location?.search)
  const urlHash = params?.get?.('hash')
  const sessionHash = sessionStorage?.getItem?.('hash')
  const pathname = window?.location?.pathname || ''
  const isUserFlowRoute = pathname === '/user' || pathname.startsWith('/user/')
  const isUserLoginRoute = pathname === '/user/login'

  if (isUserFlowRoute && !isUserLoginRoute) {
    return sessionHash || urlHash
  }

  return urlHash || sessionHash
}

export function getTagType() {
  const params = new URLSearchParams(window?.location?.search)
  return params?.get?.('tag')
}

export function replaceLoginHash(encodedHash: string) {
  const decodedHash = decodeURIComponent(encodedHash)
  setLoginHash(decodedHash)
  addHeaderHash(encodedHash)
  updateUrlLoginHash(decodedHash)
}

export function initHash() {
  const hash = getLoginHash()
  if (!hash) {
    return false
  }
  setLoginHash(hash)
  const encodedHash = encodeURIComponent(hash)
  addHeaderHash(encodedHash)
  return true
}

export function updateUrlLoginHash(hash: string) {
  if (typeof window === 'undefined' || !window?.history?.replaceState) {
    return
  }
  try {
    const url = new URL(window.location.href)
    if (url.searchParams.get('hash') === hash) {
      return
    }
    url.searchParams.set('hash', hash)
    window.history.replaceState(window.history.state, '', url.toString())
  } catch (e) {
    // URL update is best-effort; sessionStorage still holds the hash
  }
}
